import { api, API_BASE } from "./api";

export async function speak(text) {
  const r = await api("/tts", { method: "POST", body: { text } });
  const hash = r.url.split("/").pop();
  const url = `${API_BASE}/tts/${hash}`;
  if (window.__civicaAudio) window.__civicaAudio.pause();
  const a = new Audio(url);
  window.__civicaAudio = a;
  await a.play();
  return a;
}
